import { PetType } from 'constants/pet-type';

interface GetPetProfileUrlOptions {
  petType: PetType;
  params: Record<string, string>;
}
/**
 * Generates a pet profile URL with the new dynamic routing structure
 */
export const getPetProfileUrl = ({ petType, params }: GetPetProfileUrlOptions): string => {
  const resultParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    resultParams.append(key, value);
  }

  const queryString = resultParams.toString();
  return `/pet-profile/${petType}${queryString ? `?${queryString}` : ''}`;
};
